import classnames from 'classnames'
import React, { type FC } from 'react'

import { type Activity, ActivityStatus } from '../../types'
import { useActivityContent } from '@awell/ui-kit/src/compositions/ActivityFeed/useActivityContent'

import { ActivityFooter, ActivityLabel, ActivityBody } from './ActivityCard'
import { isEmpty, isNil } from 'lodash'
import { ActivityObjectType, ActivityReferenceType } from '../../../../generated/types-orchestration'

interface Props {
  onSelect?: () => void
  selected?: boolean
  activity: Activity
  handleFilterReferenceId: (referenceId: string) => void
}

export const ActivityFeedCard: FC<Props> = ({ onSelect = () => null, selected, activity, handleFilterReferenceId }) => {
  const completed = activity.status === ActivityStatus.Done || activity.status === ActivityStatus.Expired

  const { content, events } = useActivityContent(activity)
  const isAgentActivity = activity.reference_type === ActivityReferenceType.Agent

  const stepLabelColor = activity.label?.color ?? 'stepDefault'
  const stepLabelName = activity.label?.text

  // name will have patient name, but if anonymous we fallback to Anonymous
  const getStakeholderName = (): string => {
    if (!isNil(activity.indirect_object?.name) && !isEmpty(activity.indirect_object?.name)) {
      return activity.indirect_object.name
    }
    return 'Anonymous'
  }

  const isAgentActivityInitiator = activity.object.type === ActivityObjectType.Agent

  return (
    <div
      className={classnames('shadow-sm rounded-md p-6 bg-white border border-neutral-200', {
        'border-blue-700': selected
      })}
    >
      <ActivityLabel stepLabelColor={stepLabelColor} stepLabelName={stepLabelName} />

      <div className="flex flex-col gap-4">
        <ActivityBody
          activity={activity}
          content={content}
          onSelect={onSelect}
          completed={completed}
          isAgentActivity={isAgentActivity}
          isAgentActivityInitiator={isAgentActivityInitiator}
        />
        <ActivityFooter
          handleFilterReferenceId={() => handleFilterReferenceId(activity.reference_id)}
          events={events}
          stakeholder={getStakeholderName()}
          isAgentActivity={isAgentActivity}
          isAgentActivityInitiator={isAgentActivityInitiator}
          activity={activity}
        />
      </div>
    </div>
  )
}

ActivityFeedCard.displayName = 'ActivityFeedCard'
